"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: "q1",
  question: "What types of events do you DJ for?",
  answer: "D&J Entertainment provides DJ services for weddings, corporate events, private parties, school dances, and more. We bring fun, energetic, and interactive performances to any occasion."
}, {
  id: "q2",
  question: "How far in advance should I book your services?",
  answer: "We recommend booking at least 6-8 months in advance for weddings and large events to ensure availability.\xA0"
}, {
  id: "q3",
  question: "Can you customize the music playlist for my event?",
  answer: "Absolutely! We work closely with you to create a customized playlist that matches your event's vision and your music preferences. Our extensive library covers all genres."
}, {
  id: "q4",
  question: "What equipment do you provide?",
  answer: "We bring high-quality sound systems, professional lighting equipment, microphones, and all necessary cables and setup materials. Everything is included to ensure your event sounds and looks amazing."
}, {
  id: "q5",
  question: "Do you offer event planning assistance?",
  answer: "Yes! In addition to our DJ services, we offer event planning assistance to help coordinate timelines, select music, and ensure your event runs smoothly from start to finish. We utilize a user friendly app to make this as simple and thorough as possible."
}];
export default function FrequentlyAskedQuestions() {
  return <section className="relative overflow-hidden bg-light-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="font-display text-4xl sm:text-5xl font-bold text-foreground-light mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-muted text-lg">
            Got questions? We've got answers. Learn more about D&J Entertainment and how we bring the party to life.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="group border-0 rounded-lg overflow-hidden shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)]">
              <AccordionTrigger className="relative bg-dark-background hover:bg-dark-background/90 text-foreground-dark px-6 py-5 rounded-lg transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:skew-x-1 hover:-translate-y-0.5 border-0 no-underline hover:no-underline after:content-[''] after:absolute after:bottom-0 after:left-0 after:h-0.5 after:bg-accent after:w-0 after:transition-all after:duration-[var(--duration-slow)] after:ease-[var(--ease-out-back)] hover:after:w-full">
                <span className="font-display font-semibold text-lg text-left pr-4">
                  {faq.question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="bg-muted-light-background text-foreground-muted-light px-6 py-4 border-t-2 border-accent/30">
                <div className="relative">
                  <div className="absolute -left-4 top-0 w-1 h-full bg-secondary rounded-full" />
                  <p className="text-base leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>

      <div className="absolute top-10 right-10 w-32 h-32 bg-secondary/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-20 left-20 w-40 h-40 bg-accent/15 rounded-full blur-3xl pointer-events-none" />
    </section>;
}